"use client"

import IconClose from "@/app/(site)/_components/Atoms/Icons/IconClose"
import {
    useProductGridContext,
    useStaticGridContext
} from "@/app/(site)/contexts/product-grid/ProductGridContext"
import { FOCUS_VISIBLE_INSET_CLASS } from "@/src/utils/a11y/focusVisible"
import { clsx } from "@/src/utils/clsx"
import { useLangCode } from "@/src/utils/locale/useLangCode"
import { capitalizeWords } from "@/src/utils/string/capitalizeWords"
import { t } from "@/translations"

// The chip row sits flush under the sticky filter toggle, whose white 56px bar
// paints over an offset ring. Drawing the ring inside keeps it visible without
// shifting the row down.
const clearAllChipClass =
    "flex shrink-0 items-center gap-8 h-28 bg-col-border-neutral p-8 Trade_Gothic_Text_14_150_0_300"
const chipClass =
    "flex shrink-0 items-center gap-8 h-28 bg-col-bg-calm p-8 Trade_Gothic_Text_14_150_0_300"

export default function FilterChips() {
    const { filterState, clearFilter, clearAllFilters } = useProductGridContext()
    const { categoryTranslations } = useStaticGridContext()
    const langCode = useLangCode()

    const filterCount = filterState.filters.reduce((acc, f) => acc + f.data.length, 0)

    if (filterCount === 0) return null

    return (
        <>
            <button
                type="button"
                onClick={e => {
                    e.stopPropagation()
                    clearAllFilters()
                }}
                className={clsx(clearAllChipClass, FOCUS_VISIBLE_INSET_CLASS)}
                aria-label={categoryTranslations.clearAll}
            >
                <IconClose />
                <span className="pt-4">{categoryTranslations.clearAll}</span>
            </button>
            {filterState.filters.map(item =>
                item.data.map((dataItem, index) => {
                    const [label] = dataItem.split(";")
                    return (
                        <button
                            type="button"
                            key={`${label}-${index}`}
                            onClick={e => {
                                e.stopPropagation()
                                clearFilter(item.field, dataItem)
                            }}
                            className={clsx(chipClass, FOCUS_VISIBLE_INSET_CLASS)}
                            aria-label={t(langCode, "category_page.remove_filter", {
                                label
                            })}
                        >
                            <IconClose />
                            <span className="pt-4">
                                {item.field === "color_name"
                                    ? capitalizeWords(label)
                                    : label}
                            </span>
                        </button>
                    )
                })
            )}
        </>
    )
}
